import React, {useState, useRef} from 'react';
import JobModal from "../components/JobModal";

import { experiences, skills } from "../data";
const About = () => {
  const [job, setJob] = useState(null);

  const handleJobClick = (i) => {
    document.getElementById("html").classList.add("locked");
    setJob(i)
  };
  
  const renderExperience = () => {
    return experiences.map((e, i, arr) => {
      const {jobTitle, company, date, skills, summary} = e;
      return (
        <div className="exp-row" key={`${company}-${i}`} onClick={() => handleJobClick(i)}>
          <div className="left-line">
            <h2 className="text-yellow">{jobTitle}</h2>
            <h5 className="fst-italic">{company}: {date}</h5>
            <p className="mb-1">{skills.join(", ")}</p>
            <p className="job-summary">{summary}</p>
          </div>
          <div className="w-100 w-md-50 mb-5">
            <button
              className="button button-underline my-2"
              onClick={(ev) => { ev.stopPropagation(); handleJobClick(i); }}
              aria-label={`View details for ${jobTitle} at ${company}`}
            >
              details
            </button>
          </div>
        </div>
      );
    });
  };
  const renderSkills = () => {
    return skills.map(s => (
      <div className="skill-box" key={s}>{s}</div>
    ));
  };

  return (
    <div id="about" className="about-section">
      <div className="container my-5">
        <span className="section-eyebrow">Who I am</span>
        <h1>About Me</h1>
        <div className="d-flex flex-md-row flex-column py-5 px-3 px-lg-0">
          <div className="flex-4">
            <h3 className="mb-4">my story</h3>
            <div className="w-100 pe-0 pe-lg-5 mb-5">
              <p className="mb-3">My journey into software engineering began unexpectedly in 2009 when I moved to Philadelphia. Faced with the challenge of creating a website but lacking the resources to hire a developer, I took matters into my own hands and learned to code. What started as necessity quickly blossomed into passion, leading me to discover my true calling in web development. Today, I approach software engineering with both creativity and precision, finding elegant solutions to complex problems.</p>
              <p>With expertise spanning both frontend and backend development, I've built a comprehensive skill set that enables me to tackle projects from every angle. My proficiency in modern JavaScript frameworks like React.js, combined with extensive experience in cloud infrastructure using AWS and containerization with Docker and Kubernetes, allows me to develop scalable, efficient applications. More recently, AI has become an integrated part of how I build, from integrating LLMs into products to automating repetitive work and using AI-assisted tooling to move from idea to production faster than ever. I have a proven track record of creating robust, maintainable codebases using Javascript and following test-driven development practices with tools like Jest.</p>
            </div>
          </div>
          <div className="flex-3">
            <h3 className="mb-4">my skills</h3>
            <div className="d-flex flex-wrap">
              {renderSkills()}
            </div>
          </div>
        </div>
        <div className="px-3 px-lg-0">
          <h3 className="m-top-50 mb-5">experience</h3>
          {renderExperience()}
        </div>
        <JobModal
          job={job}
          callback={setJob}
        />
      </div>
    </div>
  )
}

export default About
